"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns an array built with the values between `low` and `high`. Can be reversed if `high` is less than `low`. `step` instructs the function how much to increment each array entry by.
 *
 * @see {@link https://gitlab.fitness-plus.net/developers/utils#rangelow-high-step}
 */
function range(low, high, step) {
    if (step === void 0) { step = 1; }
    var matrix = [];
    var inival = convertToInt(low);
    var endval = convertToInt(high);
    var plus = (inival > endval) ? false : true;
    var walker = step;
    if (plus) {
        while (inival <= endval) {
            matrix.push(inival);
            inival += walker;
        }
    }
    else {
        while (inival >= endval) {
            matrix.push(inival);
            inival -= walker;
        }
    }
    return matrix;
}
exports.default = range;
function convertToInt(value) {
    return parseInt(value);
}
